<template>
  <div>
    <v-dialog v-model="visible" hide-overlay transition="dialog-bottom-transition" class="sortable-handler">
        <v-card>
        <v-toolbar>
            <v-toolbar-title>{{ itemCategory }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
            <v-btn icon @click="closeModalDetail()">
                <v-icon>close</v-icon>
            </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-layout row wrap class="pa-4">
            <v-flex xs12 >
              <v-card>
                <v-layout row wrap class="pa-4">
                  <v-flex lg6 sm6 xs6>
                    <mini-statistic icon="network_check" :title="stats.nps" sub-title="NPS" :color = "stats.nps >= 0 ? 'light-green lighten-3' : 'red lighten-3'">
                    </mini-statistic>
                  </v-flex>
                  <v-flex lg6 sm6 xs6>
                    <mini-statistic icon="supervisor_account" :title="stats.totalResponses+' ('+stats.totalResponsesSmileys+')'" sub-title="Responses" color="blue lighten-4">
                    </mini-statistic>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 class="pa-1" v-if="typeFilter == 'devices'">
              <v-card class="pa-2">
                  <charts :options="chartOptions"></charts>
              </v-card>
            </v-flex>
            <v-flex xs6 class="pa-1">
              <v-card class="pa-2">
                  <p class="font-weight-thin">{{itemCategory}}</p>
                  <charts :options="chartOptionsDevicesGroup"></charts>
              </v-card>
            </v-flex>

            <v-flex xs6 class="pa-1">
              <v-card class="pa-2">
                  <p class="font-weight-thin">{{titleDetailDevice}}</p>
                  <charts :options="chartOptionsDetailDevices"></charts>
              </v-card>
            </v-flex>
            
        </v-layout>
        </v-card>
    </v-dialog>
  </div>
</template>
<script>
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
export default {
  components: {
    MiniStatistic
  },  
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: false,
    },
    datesFiltering: {
      type: Object,
      default: function () { return { startDate: 'empty', endDate: 'empty' } },
      required: false,
    },
    typeFilter: {
      type: String,
      default: 'devices',
      required: false
    },
    itemCategory: {
      type: String,
      default: null,
    },
    indexCategory: {
      type: String,
      default: null,
    },
    round_id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      stats: {
        nps: '0',
        total_responsed: '0',
        total_ommited: '0',
        total_responsed_smileys: '0',
      },
      filteringDetail: this.typeFilter,
      titleDetailDevice: 'General Rating',
      dataResponse: {},
      chartOptions: {
        chart: {
          type: 'bar'
        },
        title: {
          text: null,
        },
        subtitle: {
          text: null,
        },
        xAxis: {
          categories: ['Pregunta 1']
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Total responses smileys'
          }
        },
        tooltip: {
          shared: true,
          pointFormat: '<span style="color:{series.color}">{point.y} | {series.name}</span>: ({point.percentage:.0f}%)<br/>'
        },
        legend: {
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: 'percent',
          },
        },
        credits: {
          enabled: false
        },
        series: [{
          name: 'Bad',
          data: [0],
          color: '#ed3b3b',
        }, {
          name: 'Poor',
          data: [0],
          color: '#e87531',
        }, {
          name: 'Average',
          data: [0],
          color: '#ffd700',
        }, {
          name: 'Good',
          data: [0],
          color: '#407790',  
        }, {
          name: 'Excellent',
          data: [0],
          color: '#138315'
        }, {
          name: 'Ommited',
          data: [0],
          color: '#CDCDCD'
        }]
      },
      chartOptionsDevicesGroup: {
        chart: {
          type: 'bar'
        },
        title: {
          text: null,
        },
        subtitle: {
          text: null,
        },
        xAxis: {
          categories: ['Pregunta 1']
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Total responses smileys'
          }
        },
        tooltip: {
          shared: true,
          pointFormat: '<span style="color:{series.color}">{point.y} | {series.name}</span>: ({point.percentage:.0f}%)<br/>'
        },
        legend: {
          reversed: true
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            stacking: 'percent',
          },
        },
        credits: {
          enabled: false
        },
        series: [{
          name: 'Bad',
          data: [0],
          color: '#ed3b3b',
        }, {
          name: 'Poor',
          data: [0],
          color: '#e87531',
        }, {
          name: 'Average',
          data: [0],
          color: '#ffd700',
        }, {
          name: 'Good',
          data: [0],
          color: '#407790',  
        }, {
          name: 'Excellent',
          data: [0],
          color: '#138315'
        }, {
          name: 'Ommited',
          data: [0],
          color: '#CDCDCD'
        }]
      },
      chartOptionsDetailDevices: {
        chart: {
          type: 'bar'
        },
        title: {
          text: null,
        },
        subtitle: {
          text: null,
        },
        xAxis: {
          categories: []
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Total responses smileys'
          }
        },
        tooltip: {
          shared: true,
          pointFormat: '<span style="color:{series.color}">{point.y} | {series.name}</span>: ({point.percentage:.0f}%)<br/>'
        },
        legend: {
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: 'percent',
          },
        },
        credits: {
          enabled: false
        },
        series: [{
          name: 'Bad',
          data: [0],
          color: '#ed3b3b',
        }, {
          name: 'Poor',
          data: [0],
          color: '#e87531',
        }, {
          name: 'Average',
          data: [0],
          color: '#ffd700',
        }, {
          name: 'Good',
          data: [0],
          color: '#407790',  
        }, {
          name: 'Excellent',
          data: [0],
          color: '#138315'
        }, {
          name: 'Omitted',
          data: [0],
          color: '#CDCDCD'
        }]
      },
    };
  },
  watch: {
    dates: {
      handler: function (val, oldVal) {
        this.loadDataForDevice();
      },
      deep: true
    },
    type: {
      handler: function (val, oldVal) {
        this.loadDataForDevice();
      },
      deep: true
    }
  },
  mounted () {
    if (this.typeFilter === 'devices') {
      this.loadDataForDevice();
    } else {
      this.loadDataForGroups();
      this.loadDataForDeviceDetail(this.indexCategory);
    }
    
  },
  methods: {
    loadDataForDevice: function () {
      window.axios.get(`dashboards/round/${this.round_id}/responses-by-smileys-detail/${this.typeFilter}/${this.datesFiltering.startDate}/${this.datesFiltering.endDate}/device/${this.indexCategory}`).then(response => {
        this.stats = response.data.data.stats;
        this.chartOptions.xAxis.categories = response.data.data.questions;
        this.chartOptions.series[0].data = response.data.data.byQuestionsId.Bad;
        this.chartOptions.series[1].data = response.data.data.byQuestionsId.Poor;
        this.chartOptions.series[2].data = response.data.data.byQuestionsId.Average;
        this.chartOptions.series[3].data = response.data.data.byQuestionsId.Good;
        this.chartOptions.series[4].data = response.data.data.byQuestionsId.Excellent;
        this.chartOptions.series[5].data = response.data.data.byQuestionsId.Omitted;
      });
    },
    loadDataForGroups: function () {
      window.axios.get(`dashboards/round/${this.round_id}/responses-by-smileys-detail/devices/${this.datesFiltering.startDate}/${this.datesFiltering.endDate}/group/${this.indexCategory}`).then(response => {
        this.dataResponse = response.data.data;
        this.chartOptionsDevicesGroup.xAxis.categories = response.data.data.names;
        this.chartOptionsDevicesGroup.series[0].data = response.data.data.byLocation.Bad;
        this.chartOptionsDevicesGroup.series[1].data = response.data.data.byLocation.Poor;
        this.chartOptionsDevicesGroup.series[2].data = response.data.data.byLocation.Average;
        this.chartOptionsDevicesGroup.series[3].data = response.data.data.byLocation.Good;
        this.chartOptionsDevicesGroup.series[4].data = response.data.data.byLocation.Excellent;
        this.chartOptionsDevicesGroup.series[5].data = response.data.data.byLocation.Omitted;
        let self = this;
        this.chartOptionsDevicesGroup.plotOptions.series.point = {
          events: {
            click: function () {
              self.titleDetailDevice = this.category;
              self.filteringDetail = 'devices';
              self.loadDataForDeviceDetail(self.dataResponse.id[this.x]);
            }
          },
        };
      });
      
    },
    loadDataForDeviceDetail: function (id) {          
      window.axios.get(`dashboards/round/${this.round_id}/responses-by-smileys-detail/${this.filteringDetail}/${this.datesFiltering.startDate}/${this.datesFiltering.endDate}/device/${id}`).then(response => {
        this.stats = response.data.data.stats;
        this.chartOptionsDetailDevices.xAxis.categories = response.data.data.questions;
        this.chartOptionsDetailDevices.series[0].data = response.data.data.byQuestionsId.Bad;
        this.chartOptionsDetailDevices.series[1].data = response.data.data.byQuestionsId.Poor;
        this.chartOptionsDetailDevices.series[2].data = response.data.data.byQuestionsId.Average;
        this.chartOptionsDetailDevices.series[3].data = response.data.data.byQuestionsId.Good;
        this.chartOptionsDetailDevices.series[4].data = response.data.data.byQuestionsId.Excellent;
        this.chartOptionsDetailDevices.series[5].data = response.data.data.byQuestionsId.Omitted;
      });
    },
    closeModalDetail: function () {
      this.$emit('close-modal');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/rounds/dashboard/graphs/ModalDetailQuestionSmileys.vue